/**
 * HTML entity mappings for decoding common entities
 */
const HTML_ENTITIES: Record<string, string> = {
  amp: '&',
  apos: "'",
  lt: '<',
  gt: '>',
  quot: '"',
  nbsp: '\xa0'
} as const;

const ENTITY_PATTERN = /&([a-z]+);/gi;

/**
 * Decodes HTML entities in a text string
 * @param text - The text containing HTML entities to decode
 * @returns The decoded text with HTML entities replaced
 * @example
 * decodeHTMLEntities('Hello &amp; goodbye') // Returns: "Hello & goodbye"
 * decodeHTMLEntities('&lt;div&gt;') // Returns: "<div>"
 */
export function decodeHTMLEntities(text: string): string {
  return text.replace(ENTITY_PATTERN, (match, entity: string) => {
    const lowerEntity = entity.toLowerCase();
    return HTML_ENTITIES[lowerEntity] ?? match;
  });
}
